/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ContractWorkUnit } from './';
import {
    ContractWorkUnitFromJSON,
    ContractWorkUnitFromJSONTyped,
    ContractWorkUnitToJSON,
} from './';

/**
 * 
 * @export
 * @interface ContractWorkRate
 */
export interface ContractWorkRate {
    /**
     * 
     * @type {ContractWorkUnit}
     * @memberof ContractWorkRate
     */
    unit: ContractWorkUnit;
    /**
     * 
     * @type {number}
     * @memberof ContractWorkRate
     */
    value: number;
}

/**
 * Check if a given object implements the ContractWorkRate interface.
 */
export function instanceOfContractWorkRate(value: object): value is ContractWorkRate {
    if (!('unit' in value) || value['unit'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function ContractWorkRateFromJSON(json: any): ContractWorkRate {
    return ContractWorkRateFromJSONTyped(json, false);
}

export function ContractWorkRateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractWorkRate {
    if (json == null) {
        return json;
    }
    return {
        
        'unit': ContractWorkUnitFromJSON(json['unit']),
        'value': json['value'],
    };
}

export function ContractWorkRateToJSON(value?: ContractWorkRate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'unit': ContractWorkUnitToJSON(value['unit']),
        'value': value['value'],
    };
}

